import React from "react";
import { Popover } from "react-bootstrap";

export const TooltipStandard = React.forwardRef(
  ({ children, wide, standard = true, className, ...props }, ref) => {
    return (
      <Popover
        id="tooltip"
        ref={ref}
        content
        className={`${wide ? "popover-wide" : ""} ${
          standard ? "popover-standard" : ""
        } ${className}`}
        {...props}
        // style={{
        //   padding: ".1rem .5rem .1rem .5rem",
        //   zIndex: 200000,
        //   backgroundColor: "rgb(240,241,242)",
        //   border: "1px solid gray",
        //   borderRadius: "5px",
        //   //   marginBottom: "3px",
        // }}
      >
        {children}
      </Popover>
    );
  }
);
